// extracted by mini-css-extract-plugin
export default {"sortIcon":"ArrowIcon_sortIcon__-h7xD","left":"ArrowIcon_left__SwRx+","up":"ArrowIcon_up__ngCWp","right":"ArrowIcon_right__gDLYA","down":"ArrowIcon_down__4FW2o"};